import React from "react";
import Slide from "@material-ui/core/Slide";
import { makeStyles,DialogContent,Dialog ,Button,InputLabel,Typography } from "@material-ui/core";
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import File from '../components/formikcomponent/Imageinput';
import {string, number, mixed, object} from 'yup';
import { Formik, Field, Form,} from "formik";
import FormikTextField from "../components/formikcomponent/TextField";
const axios = require("axios").default;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function AlertDialogSlide(props) {
  const [edittopicid, setEditTopicId] = React.useState(false);
  const [topicname1, setTopicName1] = React.useState({ topicid: 0, categoryid: 0, title: "", displayorder: 0, image: [] });
  const [topic, setTopic] = React.useState();




const ERR_MESSAGE = "This field is required.";
  const topicvalidateWithSchema = object().shape({
    topicid: number().required(ERR_MESSAGE),
    categoryid: number().required(ERR_MESSAGE),
    title: string().required(ERR_MESSAGE),
    displayorder: number().required(ERR_MESSAGE),
    image: mixed().required(ERR_MESSAGE),
  });

  const COLOR = "rgb(243, 244, 245)";
  const useStyles = makeStyles((theme) => ({
    formControl: { margin: theme.spacing(1), minWidth: 120, },
    selectEmpty: { marginTop: theme.spacing(2), },
    button: {
      height: "40px",
      margin: "20px 0",
      marginRight: "20px",
      marginLeft: "20px",
      backgroundColor: "#2262bf",
      textColor: "#fff",
      color: "white",
      paddingRight: "26px",
      paddingLeft: "13px",
      fontSize: "13.7px",
      whiteSpace: "nowrap",
      cursor: "pointer",
      borderRadius: "50px",
      [theme.breakpoints.down("sm")]: {
        fontSize: '12px',
        minWidth: "120px"
      },
      '&:hover': {
        backgroundColor: "green",
        color: '#FFF'
      }
    },
    button2: { marginLeft: "9rem" },
    viewButtonLabel: { paddingLeft: "10px" },
    root: { paddingLeft: "20px", backgroundColor: COLOR, paddingRight: "20px" },
    errormessage: { color: "#f44336", fontSize: " 0.75rem", paddingTop: "3px" }, paddingBottom: { paddingBottom: "10px", paddingTop: "10px" },
    holder: { backgroundColor: 'white', paddingTop: '10px', },
    main: { maxWidth: '450px', margin: 'auto' },
  }));


  React.useEffect(() => {
    async function getUserTopic() {
      try {
        const response = await axios.get(
          `/api/resourceContentManagement/getArticleTopic`
        );

        setTopic(response.data.data);
      } catch (error) {
        console.error(error);
      }
    }
    getUserTopic();
    if (props.edittopicdata !== void (0)) {
      setEditTopicId(true);
      topicname1.topicid = props.edittopicdata[0].topicId;
      topicname1.categoryid = props.edittopicdata[0].categoryid;
      topicname1.displayorder = props.edittopicdata[0].displayOrder;
      topicname1.title = props.edittopicdata[0].title;
      topicname1.image = props.edittopicdata[0].image;
      setTopicName1({ ...topicname1 });
    }
  }, []);

  React.useEffect(() => {
    const sorttopic = () => {
      if (topic) {
        return topic.sort((a, b) => a.topicId - b.topicId);
      }
    };
    if (!edittopicid) {
      if (topic) {
        const value = sorttopic().filter((val, i) => {
          if (i === topic.length - 1) {
            return val;
          }
        });
        let display;
        const sortdisplay = () => {
          if (props.articletemplate) {
            return props.articletemplate.sort((a, b) => a.displayOrder - b.displayOrder);
          }
        };
        const value1 = sortdisplay().filter((val, i) => {
          if (i === topic.length - 1) {
            return val;
          }
        });
        let topid = value[0].topicId + 1;
        if (value1.length > 0) {
          display = value1[0].displayOrder + 1;
        } else {
          display = 1;
        }
        topicname1.categoryid = parseInt(props.selectedCategoryId);
        topicname1.topicid = topid;
        topicname1.displayorder = display;
        setTopicName1({ ...topicname1 });
      }
    }
  }, [topic]);

  const classes = useStyles();
  return (
    <div>
      <Dialog
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        maxWidth={"sm"}
        PaperProps={{ style: { backgroundColor: COLOR, boxShadow: "none" },
  }}
      >
        <DialogContent>
          <Formik enableReinitialize={true} validator={() => ({})} validationSchema={topicvalidateWithSchema} initialValues={topicname1} >
          {({ values, handleChange, isSubmitting = true, validateForm }) => (
              <Form className={classes.root}>
                <Typography variant="h5" component="h5">  Topic </Typography>
                <br />
                <div className={classes.main}>
                  <div className={classes.holder}>
                    <GridContainer>
                      <GridItem md={8} lg={8} sm={12} xs={12} className={classes.paddingBottom}>
                        <InputLabel>Topic Title</InputLabel>
                        <Field
                          name={"title"}
                          type="text"
                          component={FormikTextField}
                          variant="filled"
                          onChange={handleChange}
                        />
                      </GridItem>
                      <GridItem md={8} lg={8} sm={12} xs={12} className={classes.paddingBottom} style={{ marginBottom: "20px" }}>
                        <InputLabel >Image</InputLabel>
                        <Field
                          name={"image"}
                          component={File}
                          variant="filled"
                          onChange={handleChange}
                        />
                      </GridItem>
                      <GridItem md={12} lg={12} sm={12} xs={12} style={{ backgroundColor: COLOR, paddingTop: "10px", paddingBottom: "10px" }}></GridItem >
                      <GridItem md={12} lg={12} sm={12} xs={12} >
                        <Button classes={{ label: classes.viewButtonLabel }} autoFocus onClick={props.handleClose} className={classes.button} > {"Cancel   "} </Button>
                        <Button variant="contained" onClick={() => validateForm().then(arg => { console.log(arg);})} type="submit" disabled={(isSubmitting)} classes={{ label: classes.viewButtonLabel }} className={classes.button + " " + classes.button2} > Submit</Button>
                      </GridItem>
                      <GridItem md={12} lg={12} sm={12} xs={12} style={{ backgroundColor: COLOR, paddingTop: "10px", paddingBottom: "10px" }}></GridItem >
                    </GridContainer></div></div>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
